// src/services/api.js
import axios from 'axios';

// عنوان الـAPI من البيئة (مع افتراضي يطابق الباكند لديك)
export const apiBaseURL =
  process.env.REACT_APP_API_URL || 'http://localhost:3360';

const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: false, // لا نستخدم كوكيز حالياً
  timeout: 15000,
  headers: {
    Accept: 'application/json',
  },
});

// اعتراض واحد لإضافة التوكن و الـrole للدخول
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem('token') || localStorage.getItem('access_token');
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    const roleId = localStorage.getItem('role_id');
    if (roleId) {
      config.headers = config.headers ?? {};
      config.headers['X-ROLE-ID'] = roleId;
    }

    // Content-Type افتراضي للطلبات JSON إن لم يُضبط
    if (
      !config.headers['Content-Type'] &&
      config.data &&
      typeof config.data === 'object' &&
      !(config.data instanceof FormData)
    ) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// اعتراض الاستجابة (اختياري: هنا فقط نعيد الخطأ كما هو)
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;
